import React, { useEffect, useState } from "react";
import { Button, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { AlertGeral, requisitarAPI } from "../../components/AlertGeral";
import Listagem from "../../components/Listagens";
import { colunasListaEsperaConsultorio } from "../../components/Listagens/colunas";
import MainMenu from "../../components/MainMenu";
import Spinner from "../../components/Spiner";
import "../../Global/styleGeral.css";
import api from "../../services/api";
import { Creators as ListaEsperaAction } from "../../Store/Controls/listasEspera";

import { faPlus, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ListaEsperaConsultorio = ({ history, match }) => {
  const [retorno, setRetorno] = useState({});
  const [loading, setLoading] = useState(true);

  const listasEsperas = useSelector((state) => state.listaEspera);
  const dispatch = useDispatch();
  const tipo = match.params.tipo;
  const url_edit = `listaEspera/editar/${tipo}`;

  async function getDados() {
    let ret = await requisitarAPI(
      () => api.get(`listaEspera/${tipo}`),
      "Falha ao obter dados do servidor"
    );
    setRetorno(ret);

    if (!ret.erro) {
      dispatch(ListaEsperaAction.addEsperas(ret.response.data));
    }

    setLoading(false);
  }

  useEffect(() => {
    getDados();
  }, []);

  return (
    <>
      <MainMenu navigation={history} />

      <div className="titulo-pagina">
        {" "}
        Lista de Espera
        <Button
          variant="principal"
          onClick={() => {
            history.push(`/listaEspera/cadastro/${tipo}`);
          }}
          alt="Adicione um novo contato"
          title="Adicione um novo contato"
        >
          {" "}
          <FontAwesomeIcon className="icone" icon={faPlus} /> Novo Contato
        </Button>
        <a
          href="/ajuda"
          alt="Clique para acessar página de ajuda"
          style={{ float: "right" }}
          title="Clique para acessar página de ajuda"
        >
          <FontAwesomeIcon className="icone" icon={faQuestionCircle} />
        </a>
        <AlertGeral retorno={retorno} />
        <Spinner loading={loading} />
      </div>

      <div className="container-principal">
        <Row>
          <Listagem
            dados={listasEsperas}
            cols={colunasListaEsperaConsultorio}
            url_edit={url_edit}
            tipo_delete="listaEspera"
            history={history}
          />
        </Row>
      </div>
    </>
  );
};

export default ListaEsperaConsultorio;
